import React from 'react';

import styled, { ThemeProvider, css } from 'styled-components';
import useInkAnalytics from '../../../hooks/useInkAnalytics';
import { paginationItem, paginationItemActive } from '../styles';

const StyledItem = styled.button`
  ${paginationItem}

  ${({ theme }) =>
    theme.active &&
    css`
      ${paginationItemActive}
    `}
`;

export interface PaginationItemProps {
  page: number;
  currentPage: number;
  onChange: (page: number) => void;
}

function PaginationItem({ onChange, currentPage, page, ...otherProps }: PaginationItemProps) {
  const [ref] = useInkAnalytics(otherProps);
  return (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        active: page === currentPage,
      })}
    >
      <StyledItem
        ref={ref}
        key={`pagination-item-${page}`}
        type="button"
        onClick={() => onChange(page)}
        tabIndex={page === currentPage ? -1 : 0}
      >
        {page}
      </StyledItem>
    </ThemeProvider>
  );
}

export default PaginationItem;
